import classNames from "classnames";
import type { ReactNode } from "react";
import { Badge } from "../../../../components/Badge/Badge.tsx";
import { Icon, type IconName } from "../../../../components/Icon/Icon.tsx";
import { Info } from "../Info.tsx";

export const PanelSection = ({
  title,
  iconName,
  rightItem,
  className,
  variant = "primary",
  isBeta = false,
  infoContent,
  children,
}: {
  title?: string;
  iconName?: IconName;
  rightItem?: ReactNode;
  className?: string;
  variant?: "primary" | "secondary";
  isBeta?: boolean;
  infoContent?: ReactNode;
  children?: ReactNode;
}) => (
  <div className={classNames("flex-col gap-150 p-300 w-full", className)}>
    {title && (
      <div className="flex-row h-600 items-center justify-between">
        <div className="flex-row-center gap-150">
          {iconName && <Icon name={iconName} size="sm" />}
          <div
            className={classNames(
              variant === "primary" ? "text-primary" : "text-secondary",
              "label-md-semibold",
            )}
          >
            {title}
          </div>
          {isBeta && <Badge size="sm" label="Beta" color="emphasisSecondary" />}
          {infoContent ? <Info content={infoContent} /> : null}
        </div>
        {rightItem}
      </div>
    )}
    {children}
  </div>
);
